import { default as api } from 'config/frontApiConf';

export const getContentService = async () => {
	try {
		let result = await api.get(`/get-how-we-work-content`);
		return result;
	} catch (error) {
		return error;
	}
};
